module.exports = __webpack_public_path__ + "static/media/m-alienDefence.393cea2b.png";